document.addEventListener('DOMContentLoaded', function() {
    // Configuration object for better organization
    const config = {
        materialSlotPrefix: 'Material ',
        swatchContainerPrefix: 'swatch-container-',
        baseMaterialsCache: new Map(),
        textureCache: new Map()
    };

  
  // DOM element cache
const dom = {
    modelViewer: null,
    fabricInputs: null,
    swatchContainer: null,
    sliderWrapper: null,
    fabricPreview: null,
    previewImage: null,
    previewTitle: null,
    previewDescription: null,
    jsonLoader: null,
    selectedFabricInput: null,
    
    init() {
        this.modelViewer = document.querySelector('modern-viewer');
        this.fabricInputs = document.querySelectorAll('[id="selected-fabric"]');
        this.swatchContainer = document.querySelector('#swatch-container-0');
        this.sliderWrapper = this.swatchContainer?.querySelector('.fabric-swiper-wrapper');
        this.fabricPreview = document.querySelector('[data-fabric-preview]');
        this.previewImage = document.querySelector('[data-preview-image]');
        this.previewTitle = document.querySelector('[data-preview-title]');
        this.previewDescription = document.querySelector('[data-preview-description]');
        this.jsonLoader = document.getElementById('json-loader');
        this.selectedFabricInput = document.getElementById("selected-fabric");
    }
};


      // Initialize DOM cache
    dom.init();

  function normalizeFabricTypeForImageUrl(fabricType) {
    if (!fabricType) return '';

    return fabricType
      .replace(/\*/g, '')
      .replace(/\(QS\)/gi, '')
      .replace(/-/g, ' ')
      .replace(/[\/&]/g, ' ')
      .replace(/[\(\)]/g, '')
      .replace(/[.,:\\]|%3A/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }

  let currentlySelectedSwatch = null;
  
  // Add this new function after the currentlySelectedSwatch variable
function updateSwatchSelection(fabricType, code) {
    // Find the new swatch to select
    const newSwatch = document.querySelector(
        `#swatch-container-0 .swatches__form--label[data-fabric-type="${fabricType}"][data-swatch-code="${code}"], ` +
        `#swatch-container-0 .swatch-item-inner[data-fabric-type="${fabricType}"][data-swatch-code="${code}"]`
    );
    
    // If it's the same swatch, do nothing
    if (currentlySelectedSwatch === newSwatch) return;
    
    // Remove selected state from previous swatch
    if (currentlySelectedSwatch) {
        currentlySelectedSwatch.classList.remove('selected');
        const parentItem = currentlySelectedSwatch.parentElement;
        if (parentItem && parentItem.classList.contains('swatch-item')) {
            parentItem.classList.remove('selected');
        }
    }
    
    // Add selected state to new swatch
    if (newSwatch) {
        newSwatch.classList.add('selected');
        const parentItem = newSwatch.parentElement;
        if (parentItem && parentItem.classList.contains('swatch-item')) {
            parentItem.classList.add('selected');
        }
        currentlySelectedSwatch = newSwatch;
    }
}

  // Get product mapping from the GLB file
async function getProductMapping(modelViewer) {
    if (!modelViewer || !modelViewer.loaded) return null;
    
    try {
        await modelViewer.updateComplete;
        
        const sceneSymbol = Object.getOwnPropertySymbols(modelViewer).find(
            s => String(s).includes('scene')
        );
        const scene = modelViewer[sceneSymbol] || modelViewer.scene;
        
        if (!scene) return null;
        
        let mappingData = null;
        
        scene.traverse((node) => {
            if (node.name === 'ProductMapping' && node.userData?.variant_mapping) {
                try {
                    mappingData = JSON.parse(node.userData.variant_mapping);
                } catch (e) {
                    console.error('Failed to parse variant_mapping:', e);
                }
            }
        });
        
        return mappingData;
    } catch (error) {
        console.error('Error reading ProductMapping:', error);
        return null;
    }
}

// Update mesh visibility based on mapping
function updateMeshVisibility(modelViewer, targetMeshName) {
    if (!modelViewer || !modelViewer.loaded || !targetMeshName) return;
    
    try {
        const sceneSymbol = Object.getOwnPropertySymbols(modelViewer).find(
            s => String(s).includes('scene')
        );
        const scene = modelViewer[sceneSymbol] || modelViewer.scene;
        
        if (!scene) return;
        
        
        // Keep track of what we find
        const meshUpdates = [];
        
        scene.traverse((node) => {
            // Check if this node is a Group or Mesh that might be a variant
            if ((node.type === 'Group' || node.type === 'Mesh') && node.name) {
                // Get the product mapping to see all possible mesh names
                const mapping = modelViewer.userData?.productMapping;
                if (mapping) {
                    // Check all mapping categories
                    let isVariantMesh = false;
                    for (const category in mapping) {
                        if (category !== 'default' && mapping[category]) {
                            // Check all options in this category
                            for (const option in mapping[category]) {
                                if (mapping[category][option]?.mesh === node.name) {
                                    isVariantMesh = true;
                                    break;
                                }
                            }
                        }
                        if (isVariantMesh) break;
                    }
                    
                    if (isVariantMesh) {
                        node.visible = (node.name === targetMeshName);
                        meshUpdates.push({
                            name: node.name,
                            visible: node.visible
                        });
                    }
                }
            }
        });
        
        
        // Force render update
        if (modelViewer.renderer) {
            modelViewer.renderer.render();
        }
    } catch (error) {
        console.error('Error updating mesh visibility:', error);
    }
}

// Create a tiled texture from a low-res image
async function createTiledTexture(imageUrl, tileCount = 20) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        
        // Add cache buster to avoid CORS cache issues
        const cacheBustUrl = imageUrl + (imageUrl.includes('?') ? '&' : '?') + 'cb=' + Date.now();
        
        img.onload = function() {
            try {
                // Create canvas for tiled texture
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                
                // Set canvas size to accommodate tiled pattern
                canvas.width = img.width * tileCount;
                canvas.height = img.height * tileCount;
                
                // Draw tiled pattern
                for (let x = 0; x < tileCount; x++) {
                    for (let y = 0; y < tileCount; y++) {
                        ctx.drawImage(img, x * img.width, y * img.height, img.width, img.height);
                    }
                }
                
                // Convert canvas to blob URL
                canvas.toBlob((blob) => {
                    if (blob) {
                        const tiledUrl = URL.createObjectURL(blob);
                        resolve(tiledUrl);
                    } else {
                        reject(new Error('Failed to create blob from canvas'));
                    }
                }, 'image/jpeg', 0.9);
            } catch (error) {
                reject(new Error('Failed to create tiled texture: ' + error.message));
            }
        };
        
        img.onerror = function() {
            console.error('Failed to load image for tiling:', cacheBustUrl);
            reject(new Error('Failed to load image for tiling'));
        };
        
        // Set src after error handler is attached
        img.src = cacheBustUrl;
    });
}

// Add this helper function to check if a high-res texture exists
async function checkHighResTexture(lowResUrl) {
    // Convert finish URL to texture URL
    const highResUrl = lowResUrl.replace('/finish-', '/texture-').replace('finish-', 'texture-');
    
    try {
        // Load the high-res texture with CORS
        const img = new Image();
        img.crossOrigin = 'anonymous';
        
        return new Promise((resolve) => {
            img.onload = function() {
                // Image loaded successfully with CORS
                resolve(highResUrl);
            };
            
            img.onerror = function() {
                // High-res doesn't exist, return null
                resolve(null);
            };
            
            // Load without cache buster - this will be cached with CORS
            img.src = highResUrl;
        });
    } catch (error) {
        // High-res doesn't exist, return null
        return null;
    }
}


    // Add CSS to hide default variant selectors and add lazy loading styles
    addVariantHidingStyles();

    
    // Store the currently selected fabric information
    let lastSelectedFabric = {
        fabricType: '',
        code: '',
        imageUrl: '',
        composition: '',
        isDirect: false
    };
    
    // Intersection Observer for lazy loading
    let imageObserver = null;
    
    // ============= NEW UNIFIED MATERIAL SYSTEM =============
    
/**
 * Get the texture source for any option (swatch or standard)
 */
function getTextureForOption(optionIndex, selectedValue, optionElement) {
    // Priority 1: Check if this is a swatch system
    const swatchContainer = document.querySelector(`#${config.swatchContainerPrefix}${optionIndex}`);
    if (swatchContainer) {
        const selectedSwatch = swatchContainer.querySelector('.swatches__form--label.selected');
        if (selectedSwatch) {
            const url = selectedSwatch.dataset.lazyImage || extractImageUrl(selectedSwatch.style.backgroundImage);
            return {
                url: url,
                type: 'swatch',
                properties: {}
            };
        }
    }
    
    // Priority 2: Check base materials configuration
    const baseMaterial = lookupBaseMaterial(optionIndex, selectedValue);
    
    if (baseMaterial && baseMaterial.texture_handle) {
        const url = baseMaterial.texture_handle.startsWith('/') ?
            `https://designpublic-api-hni.s3.us-west-1.amazonaws.com${baseMaterial.texture_handle}` :
            baseMaterial.texture_handle;
        
        return {
            url: url,
            type: 'base-material',
            properties: baseMaterial.properties || {}
        };
    }
    
    // Priority 3: Check variant's own image
    const normalizedValue = normalizeFabricTypeForImageUrl(selectedValue);
    if (window.variantImageMap && window.variantImageMap[normalizedValue]) {
        const url = window.variantImageMap[normalizedValue];
        return {
            url: url,
            type: 'variant-image',
            properties: {}
        };
    }
    
    return null;
}

    
    /**
     * Lookup base material from configuration
     */
function lookupBaseMaterial(optionIndex, selectedValue) {
    // Check if materials are already loaded
    const materials = config.baseMaterialsCache.get(optionIndex);
    if (materials) {
        const material = materials[selectedValue];
        return material;
    } else {
        return null;
    }
}
  
    /**
     * Pre-load all base materials on initialization
     */
async function preloadBaseMaterials() {
    const config3D = document.getElementById('3d-config-data');
    if (!config3D) return;
    
    const baseMaterialsJsonUrl = config3D.dataset.baseMaterialsJsonUrl;
    if (!baseMaterialsJsonUrl) return;
    
    try {
        const response = await fetch(baseMaterialsJsonUrl);
        if (!response.ok) return;
        
        const data = await response.json();
        
        const productVendor = config3D.dataset.productVendor;
        
        const vendorData = data[productVendor];
        if (vendorData && vendorData.materials) {
            // Store materials for option 1 (Frame)
            config.baseMaterialsCache.set(1, vendorData.materials);
        }
    } catch (error) {
        // Silent fail in production
    }
}

    
// Updated applyTextureToMaterial with Three.js direct material access
function applyTextureToMaterial(modelViewer, textureUrl, materialName, materialProperties = {}) {
    // Add loading indicator
    const addLoadingIndicator = () => {
        if (!modelViewer.querySelector('.texture-loading-indicator')) {
            const loadingHTML = `
                <div class="texture-loading-indicator" style="
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    z-index: 100;
                    pointer-events: none;
                ">
                    <div style="
                        width: 40px;
                        height: 40px;
                        border: 3px solid rgba(255, 255, 255, 0.3);
                        border-top-color: #fff;
                        border-radius: 50%;
                        animation: spin 0.8s linear infinite;
                        box-shadow: 0 2px 10px rgba(0,0,0,0.2);
                    "></div>
                </div>
            `;
            modelViewer.insertAdjacentHTML('beforeend', loadingHTML);
        }
    };
    
    // Remove loading indicator with optional delay
    const removeLoadingIndicator = (delay = 0) => {
        setTimeout(() => {
            const indicator = modelViewer.querySelector('.texture-loading-indicator');
            if (indicator) {
                indicator.remove();
            }
        }, delay);
    };
    
    // Check for high-res version first
    checkHighResTexture(textureUrl).then(async (highResUrl) => {
        let finalTextureUrl;
        let needsCleanup = false;
        
        // Show loading indicator
        addLoadingIndicator();
        
        if (highResUrl) {
            // Use high-res texture directly
            finalTextureUrl = highResUrl;
        } else if (textureUrl.includes('/finish-')) {
            // Create tiled texture for low-res finish images
            try {
                finalTextureUrl = await createTiledTexture(textureUrl, 20);
                needsCleanup = true; // Remember to clean up blob URL later
            } catch (error) {
                console.error('Failed to create tiled texture:', error);
                // Fallback: use original URL with cache bust
                finalTextureUrl = textureUrl + (textureUrl.includes('?') ? '&' : '?') + 'cb=' + Date.now();
            }
        } else {
            // Use original URL with cache bust for other cases
            finalTextureUrl = textureUrl + (textureUrl.includes('?') ? '&' : '?') + 'cb=' + Date.now();
        }
        
        if (!modelViewer.loaded) {
            modelViewer.addEventListener('load', () => {
                applyTextureToMaterial(modelViewer, textureUrl, materialName, materialProperties);
            }, { once: true });
            return;
        }
        
        // First apply texture using model-viewer API (for the texture itself)
        const materialIndex = modelViewer.model.materials.findIndex(
            mat => mat.name === materialName
        );
        
        if (materialIndex === -1) {
            removeLoadingIndicator();
            if (needsCleanup) URL.revokeObjectURL(finalTextureUrl);
            return;
        }
        
        const img = new Image();
        img.crossOrigin = 'anonymous';
        
        img.onload = function() {
            modelViewer.createTexture(finalTextureUrl).then(texture => {
                const material = modelViewer.model.materials[materialIndex];
                
                if (!material) {
                    removeLoadingIndicator();
                    if (needsCleanup) URL.revokeObjectURL(finalTextureUrl);
                    return;
                }
                
                // Apply the texture using model-viewer API
                if (material.pbrMetallicRoughness && material.pbrMetallicRoughness.baseColorTexture) {
                    if (typeof material.pbrMetallicRoughness.baseColorTexture.setTexture === 'function') {
                        material.pbrMetallicRoughness.baseColorTexture.setTexture(texture);
                    }
                } else {
                    // Symbol-based approach for texture...
                    const pbrSymbol = Object.getOwnPropertySymbols(material).find(
                        s => String(s) === 'Symbol(pbrMetallicRoughness)'
                    );
                    
                    if (pbrSymbol) {
                        const pbr = material[pbrSymbol];
                        
                        const baseColorTextureSymbol = Object.getOwnPropertySymbols(pbr).find(
                            s => String(s) === 'Symbol(baseColorTexture)'
                        );
                        
                        if (baseColorTextureSymbol) {
                            const baseColorTexture = pbr[baseColorTextureSymbol];
                            
                            if (baseColorTexture && typeof baseColorTexture.setTexture === 'function') {
                                baseColorTexture.setTexture(texture);
                            } else if (baseColorTexture) {
                                pbr[baseColorTextureSymbol] = texture;
                            }
                        }
                    }
                }
                
                // NOW apply material properties using Three.js direct access
                if (materialProperties.roughness !== undefined || materialProperties.metalness !== undefined) {
                    // Get the Three.js scene
                    const sceneSymbol = Object.getOwnPropertySymbols(modelViewer).find(
                        s => String(s).includes('scene')
                    );
                    const scene = modelViewer[sceneSymbol];
                    
                    if (scene) {
                        // Find the mesh with this material
                        scene.traverse((node) => {
                            if (node.isMesh && node.material && node.material.name === materialName) {
                                // Apply material properties directly to Three.js material
                                if (materialProperties.roughness !== undefined) {
                                    node.material.roughness = materialProperties.roughness;
                                }
                                if (materialProperties.metalness !== undefined) {
                                    node.material.metalness = materialProperties.metalness;
                                }
                                node.material.needsUpdate = true;
                                
                          
                            }
                        });
                    }
                }
                
                // Force renders
                modelViewer.requestUpdate();
                
                const removalDelay = highResUrl ? 200 : 0;  
                removeLoadingIndicator(removalDelay);
                
                // Clean up blob URL after texture is applied
                if (needsCleanup) {
                    setTimeout(() => {
                        URL.revokeObjectURL(finalTextureUrl);
                    }, 1000);
                }
                
            }).catch(error => {
                removeLoadingIndicator();
                if (needsCleanup) URL.revokeObjectURL(finalTextureUrl);
            });
        };
        
        img.onerror = function(e) {
            // Fallback texture loading...
            modelViewer.createTexture(finalTextureUrl).then(texture => {
                const material = modelViewer.model.materials[materialIndex];
                if (material && material.pbrMetallicRoughness && material.pbrMetallicRoughness.baseColorTexture) {
                    material.pbrMetallicRoughness.baseColorTexture.setTexture(texture);
                }
                
                // Still try to apply material properties even on error
                if (materialProperties.roughness !== undefined || materialProperties.metalness !== undefined) {
                    const sceneSymbol = Object.getOwnPropertySymbols(modelViewer).find(
                        s => String(s).includes('scene')
                    );
                    const scene = modelViewer[sceneSymbol];
                    
                    if (scene) {
                        scene.traverse((node) => {
                            if (node.isMesh && node.material && node.material.name === materialName) {
                                if (materialProperties.roughness !== undefined) {
                                    node.material.roughness = materialProperties.roughness;
                                }
                                if (materialProperties.metalness !== undefined) {
                                    node.material.metalness = materialProperties.metalness;
                                }
                                node.material.needsUpdate = true;
                            }
                        });
                    }
                }
                
                removeLoadingIndicator(300);
                
                // Clean up blob URL after texture is applied
                if (needsCleanup) {
                    setTimeout(() => {
                        URL.revokeObjectURL(finalTextureUrl);
                    }, 1000);
                }
            }).catch(error => {
                removeLoadingIndicator();
                if (needsCleanup) URL.revokeObjectURL(finalTextureUrl);
            });
        };
        
        img.src = finalTextureUrl;
    });
}

    /**
     * Handle any option change (unified handler)
     */
// Universal texture and mesh swap handler
async function handleOptionChange(optionIndex, selectedValue, optionElement) {
    const modelViewer = dom.modelViewer;
    if (!modelViewer) return;
    
    // Initialize model userData if needed
    if (!modelViewer.userData) modelViewer.userData = {};
    
    // Cache the product mapping to avoid repeated reads
    if (!modelViewer.userData.productMapping) {
        modelViewer.userData.productMapping = await getProductMapping(modelViewer);
    }
    
    const productMapping = modelViewer.userData.productMapping;
    
    if (productMapping) {
        // Get the option name
        const optionGroup = document.querySelectorAll('.swatch')[optionIndex];
        const optionLabel = optionGroup?.querySelector('.option-label');
        
        // Parse option name properly
        let optionName = null;
        if (optionLabel) {
            const fullText = optionLabel.textContent.trim();
            // Split by | and take the first part
            optionName = fullText.split('|')[0].trim();
        }
        
        
        // Check if this option controls mesh visibility
        if (optionName && productMapping[optionName]) {
            const optionMapping = productMapping[optionName];
            let meshToShow = null;
            
            // Find the mesh name for this selection
            if (optionMapping[selectedValue] && optionMapping[selectedValue].mesh) {
                meshToShow = optionMapping[selectedValue].mesh;
            } else if (productMapping.default) {
                // Use default if specific selection not found
                const defaultValue = productMapping.default;
                if (optionMapping[defaultValue] && optionMapping[defaultValue].mesh) {
                    meshToShow = optionMapping[defaultValue].mesh;
                }
            }
            
            if (meshToShow) {
                updateMeshVisibility(modelViewer, meshToShow);
            }
        }
    }
    
    // Continue with existing texture update logic
    const textureInfo = getTextureForOption(optionIndex, selectedValue, optionElement);
    if (textureInfo && textureInfo.url) {
        const materialName = `${config.materialSlotPrefix}${optionIndex + 1}`;
        applyTextureToMaterial(modelViewer, textureInfo.url, materialName, textureInfo.properties);
    }
}
  
// Setup universal option listeners
async function setupUniversalOptionListeners() {
    // Pre-load product mapping if model viewer exists
    if (dom.modelViewer && dom.modelViewer.loaded) {
        if (!dom.modelViewer.userData) dom.modelViewer.userData = {};
        dom.modelViewer.userData.productMapping = await getProductMapping(dom.modelViewer);
    }
    
    // Find all option groups
    const allOptionGroups = document.querySelectorAll('.swatch');
    
    allOptionGroups.forEach((group, index) => {
        const optionIndexAttr = group.dataset.optionIndex;
        const label = group.querySelector('.option-label');
        
        // Parse the option name - extract just "Size" from "Size | Large: 31.9" W x 29.9" D x 27.2" H"
        let labelText = 'unknown';
        if (label) {
            const fullText = label.textContent.trim();
            // Split by | and take the first part
            labelText = fullText.split('|')[0].trim();
        }
        
        // Skip hidden swatch containers that are replaced by our custom UI
        if (optionIndexAttr === "1" && dom.swatchContainer) {
            return;
        }
        
        // Listen to standard variant selectors
        const inputs = group.querySelectorAll('input[type="radio"]');
        
        inputs.forEach(input => {
            input.addEventListener('change', function() {
                if (!this.checked) return;
                
                const labelElement = document.querySelector(`label[for="${this.id}"]`);
                const optionValue = labelElement ? labelElement.textContent.trim() : this.value;
                
                handleOptionChange(index, optionValue, this);
            });
        });
        
        // Trigger initial texture/mesh application if option is already selected
        const checkedInput = group.querySelector('input:checked');
        if (checkedInput) {
            const labelElement = document.querySelector(`label[for="${checkedInput.id}"]`);
            const optionValue = labelElement ? labelElement.textContent.trim() : checkedInput.value;
            setTimeout(() => handleOptionChange(index, optionValue, checkedInput), 100);
        }
    });
}
  
    // ============= END NEW UNIFIED MATERIAL SYSTEM =============
    
    // Create and show loading indicator
function showLoadingIndicator() {
    // Add loading state to container
    if (dom.swatchContainer) {
        dom.swatchContainer.classList.add('loading');
        
        // Create loading spinner HTML
        const loadingHTML = `
            <div class="fabric-loading-indicator" data-swatch-loading="0">
                <div class="fabric-loading-spinner">
                    <svg class="spinner" viewBox="0 0 50 50">
                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="4"></circle>
                    </svg>
                </div>
                <p class="fabric-loading-text">Loading fabric options...</p>
            </div>
        `;
        
        // Insert loading indicator before the wrapper
        dom.sliderWrapper.insertAdjacentHTML('beforebegin', loadingHTML);
        
        // Hide navigation buttons while loading
        const navButtons = dom.swatchContainer.querySelectorAll('.fabric-nav-btn');
        navButtons.forEach(btn => {
            btn.style.opacity = '0.5';
            btn.disabled = true;
        });
    }
    
    // Add loading state to preview if it exists
    if (dom.fabricPreview) {
        dom.fabricPreview.classList.add('loading');
        
        // Create preview loading indicator
        const previewLoadingHTML = `
            <div class="fabric-preview-loading" data-preview-loading="">
                <div class="fabric-loading-spinner">
                    <svg class="spinner" viewBox="0 0 50 50">
                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="4"></circle>
                    </svg>
                </div>
            </div>
        `;
        
        dom.fabricPreview.insertAdjacentHTML('afterbegin', previewLoadingHTML);
        
        // Hide preview content while loading
        if (dom.previewImage) dom.previewImage.style.display = 'none';
        const previewDetails = dom.fabricPreview.querySelector('.fabric-preview__details');
        if (previewDetails) previewDetails.style.display = 'none';
    }
}
    
    // Hide loading indicator
function hideLoadingIndicator() {
    // Remove loading state from container
    if (dom.swatchContainer) {
        dom.swatchContainer.classList.remove('loading');
        
        // Remove loading spinner
        const loadingEl = dom.swatchContainer.querySelector('[data-swatch-loading]');
        if (loadingEl) {
            loadingEl.remove();
        }
        
        // Re-enable navigation buttons
        const navButtons = dom.swatchContainer.querySelectorAll('.fabric-nav-btn');
        navButtons.forEach(btn => {
            btn.style.opacity = '1';
            btn.disabled = false;
        });
    }
    
    // Remove loading state from preview
    if (dom.fabricPreview) {
        dom.fabricPreview.classList.remove('loading');
        
        // Remove preview loading spinner
        const previewLoading = dom.fabricPreview.querySelector('[data-preview-loading]');
        if (previewLoading) {
            previewLoading.remove();
        }
        
        // Show preview content
        if (dom.previewImage) dom.previewImage.style.display = 'block';
        const previewDetails = dom.fabricPreview.querySelector('.fabric-preview__details');
        if (previewDetails) previewDetails.style.display = 'block';
    }
}
    
    // Initialize Intersection Observer for lazy loading
    function initializeImageObserver() {
        const options = {
            root: null,
            rootMargin: '50px',
            threshold: 0.01
        };
        
        imageObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const swatch = entry.target;
                    loadSwatchImage(swatch);
                    observer.unobserve(swatch);
                }
            });
        }, options);
    }
    
    // Load swatch image
    function loadSwatchImage(swatch) {
        const imageUrl = swatch.dataset.lazyImage;
        if (!imageUrl) return;
        
        // Create a new image to test loading
        const img = new Image();
        
        img.onload = function() {
            // Image loaded successfully
            swatch.style.backgroundImage = `url('${imageUrl}')`;
            swatch.classList.add('loaded');
            swatch.classList.remove('loading');
        };
        
        img.onerror = function() {
            // Try fallback images
            const variantFallback = swatch.dataset.variantFallback;
            const fabricType = swatch.dataset.fabricType;
            
            if (variantFallback) {
                // Try variant fallback
                const fallbackImg = new Image();
                
                fallbackImg.onload = function() {
                    swatch.style.backgroundImage = `url('${variantFallback}')`;
                    swatch.classList.add('loaded');
                    swatch.classList.remove('loading');
                };
                
                fallbackImg.onerror = function() {
                    // Try final fallback
                    if (fabricType) {
                        const finalFallback = `https://www.danishdesignstore.com/cdn/shop/files/${normalizeFabricTypeForImageUrl(fabricType)}.jpg`;
                        swatch.style.backgroundImage = `url('${finalFallback}')`;
                    }
                    swatch.classList.add('loaded');
                    swatch.classList.remove('loading');
                };
                
                fallbackImg.src = variantFallback;
            } else if (fabricType) {
                // Go straight to final fallback
                const finalFallback = `https://www.danishdesignstore.com/cdn/shop/files/${normalizeFabricTypeForImageUrl(fabricType)}.jpg`;
                swatch.style.backgroundImage = `url('${finalFallback}')`;
                swatch.classList.add('loaded');
                swatch.classList.remove('loading');
            } else {
                // No fallbacks available, just mark as loaded
                swatch.classList.add('loaded');
                swatch.classList.remove('loading');
            }
        };
        
        // Start loading
        swatch.classList.add('loading');
        img.src = imageUrl;
    }

// Automatically select the first available swatch
function selectFirstSwatch() {
    const firstSwatch = document.querySelector('#swatch-container-0 .swatches__form--label, #swatch-container-0 .swatch-item-inner');
    if (firstSwatch) {
        if (firstSwatch.dataset.lazyImage && !firstSwatch.classList.contains('loaded')) {
            loadSwatchImage(firstSwatch);
        }
        
        const fabricType = firstSwatch.dataset.fabricType;
        const code = firstSwatch.dataset.swatchCode;
        const originalValue = firstSwatch.dataset.originalValue;
        const isDirect = firstSwatch.classList.contains('direct-swatch');
        const fabricGroup = firstSwatch.dataset.fabricGroup;
        const displayName = firstSwatch.dataset.displayName;
        
        if (fabricType && code) {
            let composition = '';
            const groupElement = firstSwatch.closest('.swatches__form--group') || firstSwatch.closest('.fabric-slide');
            if (groupElement) {
                const compositionElement = groupElement.querySelector('.group_composition');
                if (compositionElement) {
                    composition = compositionElement.textContent;
                }
            }
            
            let imageUrl = firstSwatch.dataset.lazyImage || 
                `https://designpublic-api-hni.s3.us-west-1.amazonaws.com/images/finish-${normalizeFabricTypeForImageUrl(fabricType)}.jpg`;
            
            updatePreview(fabricType, imageUrl, code, composition, isDirect, displayName);
            
            firstSwatch.classList.add('selected');
            
            let fabricValue = "";
            if (currentProcessingStrategy === 'upholsteryGroup') {
                fabricValue = `${fabricType} - ${code}`;
            } else if (currentProcessingStrategy === 'upholstery') {
                fabricValue = code;
            } else if (currentProcessingStrategy === 'direct') {
                fabricValue = "";
            }
            
            document.querySelectorAll('[id="selected-fabric"]').forEach(input => {
                input.value = fabricValue;
            });
            
            // ADD THIS LINE - This is what actually updates the product variant/SKU
            selectParentVariant(fabricType, fabricGroup, originalValue, isDirect);
            
            // Set the swatch image for the first selection
            const swatchImageInput = document.getElementById('selected-swatch-image');
            if (swatchImageInput) {
                const normalizedVariant = normalizeFabricTypeForImageUrl(fabricType);
                
                const hasVariantImage = window.variantImageMap && window.variantImageMap[normalizedVariant];
                
                if (hasVariantImage) {
                    swatchImageInput.value = "";
                } else {
                    swatchImageInput.value = imageUrl;
                }
            }
            
            // Use unified handler for 3D update
            handleOptionChange(0, fabricType, firstSwatch);
        }
    }
}
    
    // Inject CSS to hide default variant selectors and add lazy loading styles
// Add CSS for the zoomed preview - add this to your addVariantHidingStyles function
function addVariantHidingStyles() {
    // Create a style element
    const styleEl = document.createElement('style');
    styleEl.type = 'text/css';
    
    // Add CSS rules including lazy loading styles and loading indicators
    styleEl.innerHTML = `
        /* Hide option 1 default display only when custom swatches are active */
        .custom-swatch-active .swatch[data-option-index="1"] .swatch-element {
            display: none !important;
        }
        .custom-swatch-active .swatch[data-option-index="1"] .option-label {
            display: none !important;
        }
        
        /* Lazy loading styles */
        .swatches__form--label {
            background-color: #f0f0f0;
            background-size: cover;
            background-position: center;
            transition: opacity 0.3s ease;
        }
        
        .swatches__form--label.loading {
            background-image: none !important;
            position: relative;
        }
        
        .swatches__form--label.loading::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 20px;
            height: 20px;
            margin: -10px 0 0 -10px;
            border: 2px solid #ddd;
            border-top-color: #333;
            border-radius: 50%;
            animation: spin 0.8s linear infinite;
        }
        
        .swatches__form--label.loaded {
            animation: fadeIn 0.3s ease;
        }
        
        /* Loading indicator styles */
        .fabric-loading-indicator {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 40px 20px;
            text-align: center;
        }
        
        .fabric-loading-spinner {
            width: 40px;
            height: 40px;
            margin-bottom: 16px;
        }
        
        .fabric-loading-spinner .spinner {
            animation: rotate 1.4s linear infinite;
        }
        
        .fabric-loading-spinner circle {
            stroke: #333;
            stroke-dasharray: 125;
            stroke-dashoffset: 125;
            animation: dash 1.4s ease-in-out infinite;
        }
        
        .fabric-loading-text {
            color: #666;
            font-size: 14px;
            margin: 0;
        }
        
        .fabric-preview-loading {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 10;
        }
        
        .fabric-swiper-container.loading .fabric-swiper-wrapper {
            opacity: 0;
            visibility: hidden;
        }
        
        /* Zoomed preview styles */
        .fabric-preview__image-container {
            overflow: hidden;
            position: relative;
            width: 100%;
            height: 100%;
        }
        
        .fabric-preview__image {
            transition: transform 0.3s ease;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        
        @keyframes spin {
            to { transform: rotate(360deg); }
        }
        
        @keyframes fadeIn {
            from { opacity: 0.7; }
            to { opacity: 1; }
        }
        
        @keyframes rotate {
            100% { transform: rotate(360deg); }
        }
        
        @keyframes dash {
            0% {
                stroke-dashoffset: 125;
            }
            50% {
                stroke-dashoffset: 0;
            }
            100% {
                stroke-dashoffset: -125;
            }
        }
    `;
    
    // Append to the document head
    document.head.appendChild(styleEl);
}

    function setCustomSwatchMode(enabled) {
        if (!document.body) return;

        document.body.classList.toggle('custom-swatch-active', Boolean(enabled));

        if (dom && dom.swatchContainer) {
            const customDisplay = dom.swatchContainer.closest('.custom_swatch_display');
            if (customDisplay) {
                customDisplay.style.display = enabled ? '' : 'none';
            }
        }
    }

    function safeJsonParse(value, fallbackValue) {
        if (!value) return fallbackValue;
        try {
            return JSON.parse(value);
        } catch (error) {
            return fallbackValue;
        }
    }

    function normalizeString(value) {
        return (value || '').toString().trim();
    }

    function normalizeLower(value) {
        return normalizeString(value).toLowerCase();
    }

    function toHandleKey(value) {
        return normalizeLower(value)
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-+|-+$/g, '');
    }

    function parsePossibleJsonArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === 'string') {
            const trimmed = value.trim();
            if (!trimmed) return [];
            try {
                const parsed = JSON.parse(trimmed);
                return Array.isArray(parsed) ? parsed : [];
            } catch (error) {
                return trimmed.split(',').map(item => item.trim()).filter(Boolean);
            }
        }
        return [];
    }

    function getMetaobjectField(entry, fieldKey) {
        if (!entry) return '';

        if (entry[fieldKey] !== undefined && entry[fieldKey] !== null) {
            return entry[fieldKey];
        }

        if (entry.fields && Array.isArray(entry.fields)) {
            const match = entry.fields.find(field => normalizeLower(field && field.key) === normalizeLower(fieldKey));
            if (match && match.value !== undefined) {
                return match.value;
            }
        }

        const prefixedKey = `field_${fieldKey}`;
        if (entry[prefixedKey] !== undefined && entry[prefixedKey] !== null) {
            return entry[prefixedKey];
        }

        return '';
    }

    function buildMetaobjectIndexes(swatchMetaobjects, upholsteryVariantMetaobjects) {
        const swatchIndex = new Map();
        const upholsteryVariantIndex = new Map();

        (swatchMetaobjects || []).forEach(item => {
            const idCandidates = [
                item && item.id,
                item && item.handle,
                getMetaobjectField(item, 'swatch_code'),
                getMetaobjectField(item, 'name')
            ];
            idCandidates.forEach(candidate => {
                const key = normalizeLower(candidate);
                if (key) swatchIndex.set(key, item);
            });
        });

        (upholsteryVariantMetaobjects || []).forEach(item => {
            const idCandidates = [
                item && item.id,
                item && item.handle,
                getMetaobjectField(item, 'variant_name'),
                getMetaobjectField(item, 'display_name')
            ];
            idCandidates.forEach(candidate => {
                const key = normalizeLower(candidate);
                if (key) upholsteryVariantIndex.set(key, item);
                const handleKey = toHandleKey(candidate);
                if (handleKey) upholsteryVariantIndex.set(handleKey, item);
            });
        });

        return { swatchIndex, upholsteryVariantIndex };
    }

    function resolveUpholsterySourceConfig(optionTitle, upholsteryTypeRaw, handlePatternRaw) {
        const upholsteryTypeList = Array.isArray(upholsteryTypeRaw) ? upholsteryTypeRaw : [];
        const handlePatternList = Array.isArray(handlePatternRaw) ? handlePatternRaw : [];
        const optionKey = normalizeLower(optionTitle);

        let sourceType = '';
        for (const item of upholsteryTypeList) {
            if (!item || typeof item !== 'object') continue;
            const itemKey = Object.keys(item).find(key => normalizeLower(key) === optionKey);
            if (itemKey) {
                sourceType = normalizeLower(item[itemKey]).replace(/["']/g, '');
                break;
            }
        }

        let patterns = [];
        for (const item of handlePatternList) {
            if (!item || typeof item !== 'object') continue;
            const itemKey = Object.keys(item).find(key => normalizeLower(key) === optionKey);
            if (itemKey) {
                const rawValue = item[itemKey];
                patterns = parsePossibleJsonArray(rawValue);
                if (patterns.length === 0 && typeof rawValue === 'string') {
                    patterns = rawValue.split(',').map(v => v.trim()).filter(Boolean);
                }
                break;
            }
        }

        return { sourceType, patterns };
    }

    function buildFabricFromVariantMetaobject(variantMetaobject, swatchIndex) {
        if (!variantMetaobject) return null;

        const variantName = normalizeString(getMetaobjectField(variantMetaobject, 'variant_name'));
        if (!variantName) return null;

        const displayName = normalizeString(getMetaobjectField(variantMetaobject, 'display_name')) || variantName;
        const swatchRefs = parsePossibleJsonArray(getMetaobjectField(variantMetaobject, 'swatches'));

        const swatches = swatchRefs.map(ref => {
            if (ref && typeof ref === 'object') {
                const refName = normalizeString(ref.name || ref.Swatch_Name || ref.swatch_name);
                const refWebName = normalizeString(ref.web_name || ref.Web_Name || refName);
                const refUrl = normalizeString(ref.url || ref.Link_Handle || ref.link_handle);
                if (refWebName && refUrl) {
                    return {
                        Swatch_Name: refName || refWebName,
                        Web_Name: refWebName,
                        Link_Handle: refUrl
                    };
                }
            }

            if (typeof ref === 'string' && /^(https?:)?\/\//.test(ref)) {
                const directName = ref.split('/').pop() || ref;
                return {
                    Swatch_Name: directName,
                    Web_Name: directName,
                    Link_Handle: ref
                };
            }

            const swatchMetaobject = swatchIndex.get(normalizeLower(ref));
            if (!swatchMetaobject) return null;

            const swatchName = normalizeString(getMetaobjectField(swatchMetaobject, 'name'));
            const swatchWebName = normalizeString(getMetaobjectField(swatchMetaobject, 'web_name')) || swatchName;
            const swatchUrl = normalizeString(getMetaobjectField(swatchMetaobject, 'url'));
            if (!swatchWebName || !swatchUrl) return null;

            return {
                Swatch_Name: swatchName || swatchWebName,
                Web_Name: swatchWebName,
                Link_Handle: swatchUrl
            };
        }).filter(Boolean);

        if (swatches.length === 0) return null;

        return {
            Upholstery_Variant: variantName,
            Display_Name: displayName,
            Composition: normalizeString(getMetaobjectField(variantMetaobject, 'composition')),
            Durability: normalizeString(getMetaobjectField(variantMetaobject, 'durability')),
            Designer: normalizeString(getMetaobjectField(variantMetaobject, 'designer')),
            Notes: normalizeString(getMetaobjectField(variantMetaobject, 'notes')),
            Swatches: swatches
        };
    }

    function buildMetaobjectDataForGroupVariants(configData, productSetMetaobjects, indexes, productHandle, productVendor, optionValues) {
        const groupData = [];
        const groups = {};
        const uniqueVariants = new Set();
        const productSetList = Array.isArray(productSetMetaobjects) ? productSetMetaobjects : [];
        const vendorHandle = toHandleKey(productVendor);
        const categorized = categorizeVariants(optionValues || []);
        const regularOptions = (categorized.regular && categorized.regular.options) || [];
        const configuredPatterns = (configData.patterns || []).map(v => normalizeString(v)).filter(Boolean);
        const patternTokens = configuredPatterns.length > 0 ? configuredPatterns : ['all-products'];

        // Primary lookup path: <vendor>-<handle_pattern>-<option-handle>
        regularOptions.forEach(optionValue => {
            const optionLabel = normalizeString(optionValue);
            if (!optionLabel) return;
            const optionHandle = toHandleKey(optionLabel);
            if (!optionHandle) return;

            const candidateHandles = patternTokens
                .map(pattern => toHandleKey(pattern))
                .filter(Boolean)
                .map(patternHandle => `${vendorHandle}-${patternHandle}-${optionHandle}`);

            if (candidateHandles.length === 0) return;

            const matchedProductSet = productSetList.find(item => {
                const itemHandle = normalizeLower(item && item.handle);
                const itemSetHandle = normalizeLower(getMetaobjectField(item, 'product_set_handle'));
                const itemCandidates = [itemHandle, itemSetHandle].filter(Boolean);
                return itemCandidates.some(candidate => candidate && candidateHandles.includes(candidate));
            });

            if (!matchedProductSet) return;

            const variantRefs = parsePossibleJsonArray(getMetaobjectField(matchedProductSet, 'variants'));

            const includes = [];

            variantRefs.forEach(ref => {
                const variantKey = normalizeLower(ref);
                const variantMetaobject =
                    (ref && typeof ref === 'object' ? ref : null) ||
                    indexes.upholsteryVariantIndex.get(variantKey) ||
                    indexes.upholsteryVariantIndex.get(toHandleKey(ref));
                const fabric = buildFabricFromVariantMetaobject(variantMetaobject, indexes.swatchIndex);
                if (!fabric) return;

                includes.push(fabric.Upholstery_Variant);
                if (!uniqueVariants.has(fabric.Upholstery_Variant.toLowerCase())) {
                    uniqueVariants.add(fabric.Upholstery_Variant.toLowerCase());
                    groupData.push(fabric);
                }
            });

            if (includes.length > 0) {
                groups[optionLabel] = { includes };
            }
        });

        if (Object.keys(groups).length > 0) {
            return {
                groupData,
                categoryData: {
                    [productVendor]: {
                        products: {
                            all_products: {
                                groups
                            }
                        }
                    }
                }
            };
        }

        // Fallback: previous loose matching logic
        productSetList.forEach(item => {
            const rawPattern = normalizeString(getMetaobjectField(item, 'handle_pattern'));
            const groupName = normalizeString(getMetaobjectField(item, 'group_name'));
            if (!rawPattern || !groupName) return;

            const patternList = rawPattern.split(',').map(v => normalizeString(v)).filter(Boolean);
            const fromMetafieldPatterns = (configData.patterns || []).map(v => normalizeString(v)).filter(Boolean);
            const patternsToMatch = fromMetafieldPatterns.length > 0 ? fromMetafieldPatterns : patternList;

            const isMatch = patternsToMatch.some(pattern => pattern && productHandle.includes(pattern));
            if (!isMatch) return;

            const variantRefs = parsePossibleJsonArray(getMetaobjectField(item, 'variants'));
            const includes = [];

            variantRefs.forEach(ref => {
                const variantMetaobject =
                    (ref && typeof ref === 'object' ? ref : null) ||
                    indexes.upholsteryVariantIndex.get(normalizeLower(ref)) ||
                    indexes.upholsteryVariantIndex.get(toHandleKey(ref));
                const fabric = buildFabricFromVariantMetaobject(variantMetaobject, indexes.swatchIndex);
                if (!fabric) return;

                includes.push(fabric.Upholstery_Variant);

                if (!uniqueVariants.has(fabric.Upholstery_Variant.toLowerCase())) {
                    uniqueVariants.add(fabric.Upholstery_Variant.toLowerCase());
                    groupData.push(fabric);
                }
            });

            if (includes.length > 0) {
                groups[groupName] = { includes };
            }
        });

        return {
            groupData,
            categoryData: {
                [productVendor]: {
                    products: {
                        all_products: {
                            groups
                        }
                    }
                }
            }
        };
    }

    function buildMetaobjectDataForUpholsteryVariants(indexes, optionValues) {
        const groupData = [];
        const seen = new Set();
        (optionValues || []).forEach(value => {
            const normalizedValue = normalizeLower(value);
            const handleValue = toHandleKey(value);
            const variantMetaobject =
                indexes.upholsteryVariantIndex.get(normalizedValue) ||
                indexes.upholsteryVariantIndex.get(handleValue);
            const fabric = buildFabricFromVariantMetaobject(variantMetaobject, indexes.swatchIndex);
            if (!fabric) return;
            const key = fabric.Upholstery_Variant.toLowerCase();
            if (seen.has(key)) return;
            seen.add(key);
            groupData.push(fabric);
        });
        return groupData;
    }

    function findSwatchMetaobjectByOption(optionValue, swatchIndex) {
        const normalized = normalizeLower(optionValue)
            .replace(/\*/g, '')
            .replace(/\(qs\)/g, '')
            .trim();
        if (!normalized) return null;

        return swatchIndex.get(normalized) || null;
    }

    function createDirectSwatchFromMetaobject(option, originalValue, swatchMetaobject) {
        const swatchWrapper = createDirectSwatch(option, originalValue);
        if (!swatchWrapper || !swatchMetaobject) return swatchWrapper;

        const label = swatchWrapper.querySelector('.swatches__form--label');
        if (!label) return swatchWrapper;

        const swatchUrl = normalizeString(getMetaobjectField(swatchMetaobject, 'url'));
        if (swatchUrl) {
            label.dataset.lazyImage = swatchUrl;
        }
        return swatchWrapper;
    }

    function tryProcessAsDirectMetaobjectSwatch(variants, swatchIndex) {
        currentProcessingStrategy = 'direct';

        const categorizedVariants = categorizeVariants(variants);
        const { featured, quickShip, regular } = categorizedVariants;
        let slideCount = 0;

        dom.sliderWrapper.innerHTML = '';

        if (featured.options.length > 0) {
            const featuredSlide = document.createElement('div');
            featuredSlide.className = 'fabric-slide';

            const featuredTitle = document.createElement('h4');
            featuredTitle.className = 'section-title';
            featuredTitle.textContent = 'Featured';
            featuredSlide.appendChild(featuredTitle);

            featured.options.forEach((option, i) => {
                const originalValue = featured.originals[i];
                const swatchMetaobject = findSwatchMetaobjectByOption(option, swatchIndex);
                const swatchEl = createDirectSwatchFromMetaobject(option, originalValue, swatchMetaobject);
                featuredSlide.appendChild(swatchEl);
            });

            dom.sliderWrapper.appendChild(featuredSlide);
            slideCount++;
        }

        if (quickShip.options.length > 0) {
            const quickShipSlide = document.createElement('div');
            quickShipSlide.className = 'fabric-slide';

            const quickShipTitle = document.createElement('h4');
            quickShipTitle.className = 'section-title';
            quickShipTitle.textContent = 'Quick Ship';
            quickShipSlide.appendChild(quickShipTitle);

            quickShip.options.forEach((option, i) => {
                const originalValue = quickShip.originals[i];
                const swatchMetaobject = findSwatchMetaobjectByOption(option, swatchIndex);
                const swatchEl = createDirectSwatchFromMetaobject(option, originalValue, swatchMetaobject);
                quickShipSlide.appendChild(swatchEl);
            });

            dom.sliderWrapper.appendChild(quickShipSlide);
            slideCount++;
        }

        if (regular.options.length > 0) {
            const regularSlide = document.createElement('div');
            regularSlide.className = 'fabric-slide';

            const optionTitle = dom.jsonLoader.dataset.optionTitle || 'Options';
            const regularTitle = document.createElement('h4');
            regularTitle.className = 'section-title';
            regularTitle.textContent = optionTitle;
            regularSlide.appendChild(regularTitle);

            regular.options.forEach((option, i) => {
                const originalValue = regular.originals[i];
                const swatchMetaobject = findSwatchMetaobjectByOption(option, swatchIndex);
                const swatchEl = createDirectSwatchFromMetaobject(option, originalValue, swatchMetaobject);
                regularSlide.appendChild(swatchEl);
            });

            dom.sliderWrapper.appendChild(regularSlide);
            slideCount++;
        }

        if (slideCount === 0) {
            return false;
        }

        dom.swatchContainer.style.display = 'block';
        setCustomSwatchMode(true);
        initializeSlider(dom.swatchContainer, slideCount);
        attachSwatchListeners();
        observeSwatches();
        selectFirstSwatch();
        hideLoadingIndicator();

        return true;
    }

    // Load JSON data and start the cascade processing
async function loadData() {
    // Show loading indicator immediately
    showLoadingIndicator();
    setCustomSwatchMode(false);
    
    // Reset the selected swatch tracker
    currentlySelectedSwatch = null;
    
    // Get basic parameters
    const variants = safeJsonParse(dom.jsonLoader.dataset.productVariants, []);
    
    try {
        let groupData = null;
        let categoryData = null;
        const productHandle = dom.jsonLoader.dataset.productHandle;
        const productVendor = dom.jsonLoader.dataset.productVendor;

        const optionTitle = dom.jsonLoader.dataset.optionTitle || dom.jsonLoader.dataset.optionName;
        const upholsteryType = safeJsonParse(dom.jsonLoader.dataset.upholsteryType, []);
        const handlePattern = safeJsonParse(dom.jsonLoader.dataset.handlePattern, []);
        const sourceConfig = resolveUpholsterySourceConfig(optionTitle, upholsteryType, handlePattern);

        if (!sourceConfig.sourceType || sourceConfig.sourceType === 'none') {
            tryProcessAsDirect(variants);
            return;
        }

        const swatchMetaobjects = safeJsonParse(dom.jsonLoader.dataset.swatchMetaobjects, []);
        const upholsteryVariantMetaobjects = safeJsonParse(dom.jsonLoader.dataset.upholsteryVariantMetaobjects, []);
        const productSetMetaobjects = safeJsonParse(dom.jsonLoader.dataset.productSetMetaobjects, []);
        const indexes = buildMetaobjectIndexes(swatchMetaobjects, upholsteryVariantMetaobjects);

        if (sourceConfig.sourceType === 'group-variants') {
                const metaobjectData = buildMetaobjectDataForGroupVariants(sourceConfig, productSetMetaobjects, indexes, productHandle, productVendor, variants);
            groupData = metaobjectData.groupData;
            categoryData = metaobjectData.categoryData;
        } else if (sourceConfig.sourceType === 'upholstery-variants') {
            groupData = buildMetaobjectDataForUpholsteryVariants(indexes, variants);
            categoryData = null;
        } else if (sourceConfig.sourceType === 'swatch' || sourceConfig.sourceType === 'swatches') {
            tryProcessAsDirect(variants);
            return;
        } else {
            tryProcessAsDirect(variants);
            return;
        }

        if (!groupData || groupData.length === 0) {
            hideLoadingIndicator();
            setCustomSwatchMode(false);
            return;
        }

        // Process the data through the cascade
        await processDataCascade(groupData, categoryData, variants, productVendor, productHandle);
        
    } catch (error) {
        // Hide loading indicator on error
        hideLoadingIndicator();
        setCustomSwatchMode(false);
        
        // Show error message
        const errorDiv = document.createElement('div');
        errorDiv.className = 'fabric-error';
        errorDiv.textContent = 'Unable to load upholstery variant options. Please try refreshing the page.';
        dom.jsonLoader.parentNode.insertBefore(errorDiv, dom.jsonLoader);
    }
}

    //Track which strategy is used to process fabrics:
    let currentProcessingStrategy = '';
    
    // New cascade processing function that tries different approaches in sequence
    async function processDataCascade(groupData, categoryData, variants, productVendor, productHandle) {
        let processSuccess = false;
        
        // Initialize the image observer before processing
        initializeImageObserver();
        
        // STRATEGY 1: Try processing as Upholstery Group first
        if (categoryData) {
            processSuccess = await tryProcessAsUpholsteryGroup(groupData, categoryData, variants, productVendor, productHandle);
        }
        
        // STRATEGY 2: If no success, try processing as general Upholstery
        if (!processSuccess) {
            processSuccess = tryProcessAsUpholstery(groupData, variants);
        }
        
        // STRATEGY 3: If still no success, fall back to direct matching
        if (!processSuccess) {
            processSuccess = tryProcessAsDirect(variants);
            if (!processSuccess) {
                // Hide loading indicator if all strategies fail
                hideLoadingIndicator();
                setCustomSwatchMode(false);
            }
        }
    }
    
    // Sort variants into featured, quick ship, and regular
    function categorizeVariants(variants) {
        const featured = { options: [], originals: [] };
        const quickShip = { options: [], originals: [] };
        const regular = { options: [], originals: [] };
        
        variants.forEach(value => {
            if (value.includes('*')) {
                // Featured items are ALWAYS direct matches
                const cleanValue = value.replace('*', '').trim();
                featured.options.push(cleanValue);
                featured.originals.push(value);
            } else if (value.includes('(QS)')) {
                // Quick Ship items are ALWAYS direct matches
                const cleanValue = value.replace('(QS)', '').trim();
                quickShip.options.push(cleanValue);
                quickShip.originals.push(value);
            } else {
                // Only regular variants might match JSON data
                regular.options.push(value);
                regular.originals.push(value);
            }
        });
        
        return { featured, quickShip, regular };
    }
    
    // Helper to create Featured/QS slides (always direct)
    function createDirectVariantSlides(featured, quickShip, sliderWrapper) {
        let slideCount = 0;
        
        // Create Featured slide if applicable
        if (featured.options.length > 0) {
            const featuredSlide = document.createElement('div');
            featuredSlide.className = 'fabric-slide';
            
            const featuredTitle = document.createElement('h4');
            featuredTitle.className = 'section-title';
            featuredTitle.textContent = 'Featured';
            featuredSlide.appendChild(featuredTitle);
            
            // Add all featured options as direct swatches
            featured.options.forEach((option, i) => {
                const originalValue = featured.originals[i];
                const swatchEl = createDirectSwatch(option, originalValue);
                featuredSlide.appendChild(swatchEl);
            });
            
            dom.sliderWrapper.appendChild(featuredSlide);
            slideCount++;
        }
        
        // Create Quick Ship slide if applicable
        if (quickShip.options.length > 0) {
            const quickShipSlide = document.createElement('div');
            quickShipSlide.className = 'fabric-slide';
            
            const quickShipTitle = document.createElement('h4');
            quickShipTitle.className = 'section-title';
            quickShipTitle.textContent = 'Quick Ship';
            quickShipSlide.appendChild(quickShipTitle);
            
            // Add all quick ship options as direct swatches
            quickShip.options.forEach((option, i) => {
                const originalValue = quickShip.originals[i];
                const swatchEl = createDirectSwatch(option, originalValue);
                quickShipSlide.appendChild(swatchEl);
            });
            
            dom.sliderWrapper.appendChild(quickShipSlide);
            slideCount++;
        }
        
        return slideCount;
    }
    
    // Process as Upholstery Group (with category data)
    async function tryProcessAsUpholsteryGroup(groupData, categoryData, variants, productVendor, productHandle) {
        // Set the strategy flag
        currentProcessingStrategy = 'upholsteryGroup';
        
        const categorizedVariants = categorizeVariants(variants);
        const { featured, quickShip, regular } = categorizedVariants;
        
        // First, create slides for Featured/QS (always direct)
        let slideCount = createDirectVariantSlides(featured, quickShip, dom.sliderWrapper);
        
        // Find applicable groups
        const { applicableGroups, isSpecificMatch } = findApplicableGroups(categoryData, productVendor, productHandle);
        
        // Filter fabric groups by applicable groups
        const filteredGroups = filterFabricGroups(groupData, applicableGroups);

        // Create a set of all available category names from filtered groups
        const availableCategories = new Set();
        filteredGroups.forEach(group => {
            if (group.categoryName) {
                availableCategories.add(group.categoryName);
            }
        });

        // Check if any regular fabrics match a category
        let realCategoryMatches = 0;
        regular.options.forEach(option => {
            if (availableCategories.has(option.trim())) {
                realCategoryMatches++;
            }
        });

        // If we don't have any real category matches, force this strategy to fail
        if (realCategoryMatches === 0 || filteredGroups.length === 0) {
            // Remove any slides we created
            dom.sliderWrapper.innerHTML = '';
            return false;
        }
        
        // Process matched regular variants
        filteredGroups.forEach(fabric => {
            if (!fabric.Display_Name || !fabric.Swatches || fabric.Swatches.length === 0) {
                return;
            }
            
            // Only create slides for regular variants that match
            const isRegularMatch = regular.options.some(opt => opt.trim() === fabric.categoryName);
            if (!isRegularMatch) return;
            
            const slide = document.createElement('div');
            slide.className = 'fabric-slide';
            
            const fabricGroup = createFabricGroup(fabric, fabric.Upholstery_Variant, fabric.categoryName);
            if (fabricGroup) {
                slide.appendChild(fabricGroup);
                dom.sliderWrapper.appendChild(slide);
                slideCount++;
            }
        });
        
        if (slideCount === 0) {
            return false;
        }
        
        // Show container and initialize
        dom.swatchContainer.style.display = 'block';
        setCustomSwatchMode(true);
        initializeSlider(dom.swatchContainer, slideCount);
        attachSwatchListeners();
        observeSwatches();
        selectFirstSwatch();
        hideLoadingIndicator();
        
        return true;
    }
    
    // Process as general Upholstery (direct lookup in groupData)
    function tryProcessAsUpholstery(groupData, variants) {
        // Set the strategy flag
        currentProcessingStrategy = 'upholstery';
        
        const categorizedVariants = categorizeVariants(variants);
        const { featured, quickShip, regular } = categorizedVariants;
        
        // First, create slides for Featured/QS (always direct)
        let slideCount = createDirectVariantSlides(featured, quickShip, dom.sliderWrapper);
        
        // Only check regular variants for matches
        const matchedRegular = [];
        
        for (let i = 0; i < regular.options.length; i++) {
            const option = regular.options[i];
            const matchingFabric = findFabricByName(option, groupData);
            if (matchingFabric) {
                matchedRegular.push(i);
            }
        }
        
        // If no regular matches and no featured/QS, fail this strategy
        if (matchedRegular.length === 0 && featured.options.length === 0 && quickShip.options.length === 0) {
            dom.sliderWrapper.innerHTML = '';
            return false;
        }
        
        // Create slides for matched regular options
        matchedRegular.forEach(index => {
            const option = regular.options[index];
            const matchingFabric = findFabricByName(option, groupData);
            
            if (matchingFabric) {
                const regularSlide = document.createElement('div');
                regularSlide.className = 'fabric-slide';
                
                const fabricGroup = createFabricGroup(matchingFabric, option);
                if (fabricGroup) {
                    regularSlide.appendChild(fabricGroup);
                    dom.sliderWrapper.appendChild(regularSlide);
                    slideCount++;
                }
            }
        });
        
if (matchedRegular.length === 0) {
    dom.sliderWrapper.innerHTML = '';
    return false;
}
        
        // Show container and initialize
        dom.swatchContainer.style.display = 'block';
        setCustomSwatchMode(true);
        initializeSlider(dom.swatchContainer, slideCount);
        attachSwatchListeners();
        observeSwatches();
        selectFirstSwatch();
        hideLoadingIndicator();
        
        return true;
    }
    
    // Process as direct (fallback strategy)
    function tryProcessAsDirect(variants) {
        // Set the strategy flag
        currentProcessingStrategy = 'direct';
        
        const categorizedVariants = categorizeVariants(variants);
        const { featured, quickShip, regular } = categorizedVariants;
        
        // Create slides for all variants as direct
        let slideCount = createDirectVariantSlides(featured, quickShip, dom.sliderWrapper);
        
        // Add regular options slide
        if (regular.options.length > 0) {
            const regularSlide = document.createElement('div');
            regularSlide.className = 'fabric-slide';
            
            const optionTitle = dom.jsonLoader.dataset.optionTitle || 'Options';
            const regularTitle = document.createElement('h4');
            regularTitle.className = 'section-title';
            regularTitle.textContent = optionTitle;
            regularSlide.appendChild(regularTitle);
            
            // Add all regular options as direct swatches
            regular.options.forEach(option => {
                const swatchEl = createDirectSwatch(option, option);
                regularSlide.appendChild(swatchEl);
            });
            
            dom.sliderWrapper.appendChild(regularSlide);
            slideCount++;
        }
        
        if (slideCount === 0) {
            return false;
        }
        
        // Show container and initialize
        dom.swatchContainer.style.display = 'block';
        setCustomSwatchMode(true);
        initializeSlider(dom.swatchContainer, slideCount);
        attachSwatchListeners();
        observeSwatches();
        selectFirstSwatch();
        hideLoadingIndicator();
        
        return true;
    }
    
    // Observe swatches for lazy loading
    function observeSwatches() {
        if (!imageObserver) return;
        
        // Find all swatches with lazy loading data
        const swatches = document.querySelectorAll('#swatch-container-0 .swatches__form--label[data-lazy-image]');
        swatches.forEach(swatch => {
            imageObserver.observe(swatch);
        });
    }

    // Find applicable fabric groups for the product based on vendor and handle
    function findApplicableGroups(categoryData, productVendor, productHandle) {
        // Default to empty groups
        let applicableGroups = {};
        let isSpecificMatch = false;
        
        // Check if vendor exists in data
        const vendorData = categoryData[productVendor];
        if (!vendorData || !vendorData.products) {
            return { applicableGroups, isSpecificMatch };
        }
        
        // First check for specific product matches
        const products = vendorData.products;
        
        // Loop through product patterns
        for (const handlePattern in products) {
            // Skip all_products and "all products" for now
            if (handlePattern === 'all_products' || handlePattern === 'all products') continue;
            
            // Check if any pattern matches the current product handle
            const patterns = handlePattern.split(',').map(p => p.trim());
            if (patterns.some(pattern => productHandle.includes(pattern))) {
                // We found a match!
                applicableGroups = products[handlePattern].groups || {};
                isSpecificMatch = true;
                break;
            }
        }
        
        // If no specific match, use all_products or "all products" if available
        if (!isSpecificMatch) {
            if (products.all_products) {
                applicableGroups = products.all_products.groups || {};
            } else if (products['all products']) {
                applicableGroups = products['all products'].groups || {};
            }
        }
        
        return { applicableGroups, isSpecificMatch };
    }
    
    // Filter fabric groups based on applicable groups
    function filterFabricGroups(groupData, applicableGroups) {
        const result = [];
        
        // For each category and its included fabrics
        for (const categoryName in applicableGroups) {
            const includes = applicableGroups[categoryName].includes || [];
            
            // For each included fabric, find its details in groupData
            includes.forEach(fabricId => {
                // Find matching fabric group
                const fabricGroup = groupData.find(group => 
                    group.Upholstery_Variant === fabricId
                );
                
                if (fabricGroup) {
                    // Add category information to the fabric group
                    result.push({
                        ...fabricGroup,
                        categoryName: categoryName // Store the category name
                    });
                }
            });
        }
        
        return result;
    }

    // Find fabric group by name
    function findFabricByName(name, fabricGroups) {
        const nameLower = name.toLowerCase();
        return fabricGroups.find(fabric => 
            fabric.Upholstery_Variant && 
            fabric.Upholstery_Variant.toLowerCase() === nameLower && 
            fabric.Swatches && 
            fabric.Swatches.length > 0
        );
    }

    // Helper function to decode HTML entities
    function decodeHTMLEntities(text) {
        if (!text) return '';
        
        const textArea = document.createElement('textarea');
        textArea.innerHTML = text;
        return textArea.value;
    }
    
// Create a fabric group element with lazy loading
function createFabricGroup(fabric, originalValue, categoryName) {
    if (!fabric.Swatches || fabric.Swatches.length === 0) return null;
     const swatchDiv = dom.jsonLoader;

    // Get the value of a specific attribute, for example, a data attribute
    const optName = swatchDiv ? swatchDiv.getAttribute('data-option-name') : null;
    
    const fabricGroup = document.createElement('div');
    fabricGroup.className = 'swatches__form--group';
    fabricGroup.dataset.fabricType = fabric.Upholstery_Variant;
    
    // Add title
    const titleElement = document.createElement('h4');
    titleElement.className = 'swatches__form--title';
    titleElement.textContent = fabric.Display_Name;
    fabricGroup.appendChild(titleElement);
    
    // Add fabric information when available
    const infoContainer = document.createElement('div');
    infoContainer.className = 'fabric-info-container';
    
    // Add composition if available
    if (fabric.Composition) {
        const compositionElement = document.createElement('div');
        compositionElement.className = 'group_composition';
        compositionElement.textContent = `${decodeHTMLEntities(fabric.Composition)}`;
        infoContainer.appendChild(compositionElement);
    }
    
    // Add durability if available
    if (fabric.Durability) {
        const durabilityElement = document.createElement('div');
        durabilityElement.className = 'group_durability';
        durabilityElement.textContent = `${decodeHTMLEntities(fabric.Durability)}`;
        infoContainer.appendChild(durabilityElement);
    }
    
    // Add designer if available
    if (fabric.Designer) {
        const designerElement = document.createElement('div');
        designerElement.className = 'group_designer';
        designerElement.textContent = `${decodeHTMLEntities(fabric.Designer)}`;
        infoContainer.appendChild(designerElement);
    }
    
    // Add notes if available
    if (fabric.Notes) {
        const notesElement = document.createElement('div');
        notesElement.className = 'group_notes';
        notesElement.textContent = `${decodeHTMLEntities(fabric.Notes)}`;
        infoContainer.appendChild(notesElement);
    }
    
    // Only append the container if it has any children
    if (infoContainer.children.length > 0) {
        fabricGroup.appendChild(infoContainer);
    }
    
    // Create a container for swatches
    const swatchesContainer = document.createElement('div');
    swatchesContainer.className = 'swatches__form--wrapper-container';
    fabricGroup.appendChild(swatchesContainer);
    
    // Add swatches to the container with lazy loading
    fabric.Swatches.forEach(swatch => {
        // Construct image URL
        const imageUrl = swatch.Link_Handle.startsWith('/') ?
            `https://designpublic-api-hni.s3.us-west-1.amazonaws.com${swatch.Link_Handle}` :
            swatch.Link_Handle;
        
        const swatchWrapper = document.createElement('div');
        swatchWrapper.className = 'swatches__form--wrapper';
        
        swatchWrapper.innerHTML = `
            <label class="swatches__form--label"
                  for="swatch-${fabric.Upholstery_Variant.toLowerCase().replace(/\s+/g, '-')}-${swatch.Web_Name}"
                  tabindex="0"
                  data-lazy-image="${imageUrl}"
                  data-swatch-code="${swatch.Web_Name}"
                  data-fabric-type="${fabric.Upholstery_Variant}"
                  ${categoryName ? `data-fabric-group="${categoryName}"` : ''}
                  data-original-value="${originalValue}"
                  data-swatch-name="${fabric.Display_Name}"
                  data-display-name="${fabric.Display_Name}"
                  data-option-name="${optName}">
            </label>
            <span class="swatches__form--name">
              ${swatch.Web_Name}
            </span>
        `;
        
        swatchesContainer.appendChild(swatchWrapper);
    });
    
    return fabricGroup;
}
    
    // Create a direct swatch with lazy loading
function createDirectSwatch(option, originalValue) {
    const cleanOption = option.replace(/\*/g, '').replace(/\(QS\)/gi, '').trim();
    const f = normalizeFabricTypeForImageUrl(option);
    const swatchUrl = `https://designpublic-api-hni.s3.us-west-1.amazonaws.com/images/finish-${f}.jpg`;
    
    // Get the fallback variant image if it exists
    const variantImageUrl = window.variantImageMap && window.variantImageMap[f];
    
    const swatchWrapper = document.createElement('div');
    swatchWrapper.className = 'swatches__form--wrapper';
    
    swatchWrapper.innerHTML = `
        <label class="swatches__form--label direct-swatch"
              for="swatch-${f}"
              tabindex="0"
              data-lazy-image="${swatchUrl}"
              data-swatch-code="${cleanOption}"
              data-fabric-type="${cleanOption}"
              data-original-value="${originalValue}"
              data-variant-fallback="${variantImageUrl || ''}">
        </label>
        <span class="swatches__form--name">${originalValue}</span>
    `;
    
    return swatchWrapper;
}
    
    // Extract image URL from background-image style
    function extractImageUrl(bgImage) {
        if (bgImage && bgImage !== 'none') {
            return bgImage.slice(5, -2); // Remove url(" and ")
        }
        return '';
    }

// Handle swatch click event
function handleSwatchClick(event) {
    const swatch = event.currentTarget;
    const fabricType = swatch.dataset.fabricType;
    const fabricGroup = swatch.dataset.fabricGroup;
    const code = swatch.dataset.swatchCode;
    const originalValue = swatch.dataset.originalValue;
    const displayName = swatch.dataset.displayName;
    
    // For lazy loaded images, ensure image is loaded before using
    if (swatch.dataset.lazyImage && !swatch.classList.contains('loaded')) {
        loadSwatchImage(swatch);
    }
    
    const bgImage = swatch.style.backgroundImage;
    
    // Validate we have required data
    if (!fabricType || !code) return;
    
    // Determine if this is a direct swatch
    const isDirect = swatch.classList.contains('direct-swatch');
    
    // Find composition if available
    let composition = '';
    const groupElement = swatch.closest('.swatches__form--group') || swatch.closest('.fabric-slide');
    if (groupElement) {
        const compositionElement = groupElement.querySelector('.group_composition');
        if (compositionElement) {
            composition = compositionElement.textContent;
        }
    }
    
    // Extract image URL and clean it
    let imageUrl = extractImageUrl(bgImage);
    if (!imageUrl) {
        // Use the lazy image URL if available
        imageUrl = swatch.dataset.lazyImage || 
            `https://designpublic-api-hni.s3.us-west-1.amazonaws.com/images/finish-${normalizeFabricTypeForImageUrl(fabricType)}.jpg`;
    }
            
    updatePreview(fabricType, imageUrl, code, composition, isDirect, displayName);
    selectParentVariant(fabricType, fabricGroup, originalValue, isDirect);
    
    // Check if this variant has its own image - IMPROVED NORMALIZATION
    const normalizedVariant = normalizeFabricTypeForImageUrl(fabricType);
    
    // Also check with -qs suffix since Quick Ship items have this
    const hasVariantImage = window.variantImageMap && (
        window.variantImageMap[normalizedVariant] || 
        window.variantImageMap[normalizedVariant + '-qs']
    );
    
    // Use different timing based on whether variant has image
    if (hasVariantImage) {
        // Variant has image - delay the 3D update more to prevent flip-back
        setTimeout(() => {
            handleOptionChange(0, fabricType, swatch);
        }, 150);
        
        // Don't trigger the generic image check - let the theme handle it naturally
    } else {
        // No variant image - update 3D quickly and trigger image check to show 3D
        setTimeout(() => {
            handleOptionChange(0, fabricType, swatch);
        }, 50);
        
        // Trigger image check to ensure we show 3D model
        setTimeout(() => {
            if (typeof Events !== 'undefined') {
                Events.trigger('variantchange:image', null, document.querySelector('[data-section-type="product-section"]'));
            }
        }, 100);
    }
    
    // Prevent event from bubbling up
    event.stopPropagation();
}
  
function updatePreview(fabricType, imageUrl, code, composition, isDirect, displayName) {
    // Guard against missing data or elements
    if (!fabricType || !imageUrl || !code || 
        !dom.previewImage || !dom.previewTitle || !dom.previewDescription || !dom.selectedFabricInput) {
        return;
    }
    
    // Get normalized option for variant image lookup
    // Fix: First replace existing hyphens with spaces, then normalize
    const normalizedOption = normalizeFabricTypeForImageUrl(fabricType);
    
    const variantImageUrl = window.variantImageMap && window.variantImageMap[normalizedOption];
    
    // Save the current selection with fallback reference
    lastSelectedFabric = {
        fabricType,
        code,
        imageUrl,
        variantImageUrl,
        composition,
        isDirect,
        displayName
    };
    
    dom.fabricPreview.style.display = 'block';
    
    // Update swatch property with low-res URL only
    const swatchImageInput = document.getElementById('selected-swatch-image');
    if (swatchImageInput) {
        // Simple rule: If variant has an image, don't store swatch. Otherwise, store it.
        if (variantImageUrl) {
            // Variant has its own image, clear the swatch property
            swatchImageInput.value = "";
        } else {
            // No variant image, store the low-res swatch URL
            swatchImageInput.value = imageUrl;
        }
    }
    
    // Rest of the preview update logic (still uses high-res for display)...
    checkHighResTexture(imageUrl).then(highResUrl => {
        const finalImageUrl = highResUrl || imageUrl;
        
        // Only update preview if this is still the selected fabric
        if (lastSelectedFabric.fabricType !== fabricType || lastSelectedFabric.code !== code) {
            return; // User has selected something else, abandon this update
        }
        
        // Set up image error handling directly on the preview image
        dom.previewImage.onerror = function() {
            if (variantImageUrl) {
                dom.previewImage.src = variantImageUrl;
                dom.previewImage.onerror = function() {
                    const finalFallbackUrl = `https://www.danishdesignstore.com/cdn/shop/files/${normalizedOption}.jpg`;
                    dom.previewImage.src = finalFallbackUrl;
                    dom.previewImage.onerror = null;
                };
            } else {
                const finalFallbackUrl = `https://www.danishdesignstore.com/cdn/shop/files/${normalizedOption}.jpg`;
                dom.previewImage.src = finalFallbackUrl;
                dom.previewImage.onerror = null;
            }
        };
        
        // Set the image
        dom.previewImage.src = finalImageUrl;
        dom.previewImage.alt = `${fabricType} ${code}`;
        
        // Apply zoom if high-res texture is available
        if (highResUrl) {
            dom.previewImage.style.transform = 'scale(4)';
            dom.previewImage.style.transformOrigin = 'center center';
            
            const imageContainer = dom.previewImage.parentElement;
            if (imageContainer) {
                imageContainer.style.overflow = 'hidden';
                imageContainer.style.position = 'relative';
            }
        } else {
            dom.previewImage.style.transform = 'scale(1)';
            dom.previewImage.style.transformOrigin = 'center center';
        }
        
        lastSelectedFabric.imageUrl = finalImageUrl;
    });
    
    // For direct swatches, just show the code as the title to avoid duplication
    dom.previewTitle.textContent = isDirect ? code : `${displayName || fabricType} - ${code}`;
    
    // Use the proper composition if available, otherwise leave empty
    dom.previewDescription.textContent = (composition && composition.trim()) ? composition : '';
    
    // Determine the fabric value based on the processing strategy
    let fabricValue = "";
    
    if (currentProcessingStrategy === 'upholsteryGroup') {
        fabricValue = `${fabricType} - ${code}`;
    } else if (currentProcessingStrategy === 'upholstery') {
        fabricValue = code;
    } else if (currentProcessingStrategy === 'direct') {
        fabricValue = "";
    }
    
    // Update ALL elements with ID "selected-fabric"
    dom.fabricInputs.forEach(input => {
        input.value = fabricValue;
    });

    // Use the new efficient selection update
    updateSwatchSelection(fabricType, code);
}


  async function getImageDimensions(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => resolve({ width: img.width, height: img.height });
        img.onerror = () => reject(new Error('Failed to load image'));
        img.src = url;
    });
}

    
    // Fixed version of selectParentVariant that updates both the selection and line item property
    function selectParentVariant(fabricType, fabricGroup, originalValue, isDirect) {
        // Determine the correct search value - prioritize category groups for non-direct swatches
        let searchValue;
        if (fabricGroup && !isDirect) {
            // For category-based swatches (e.g. CAT 2), use the category name
            searchValue = fabricGroup.toLowerCase();
        } else if (originalValue) {
            // Fall back to original value if provided
            searchValue = originalValue.toLowerCase();
        } else {
            // Last resort: use fabric type
            searchValue = fabricType.toLowerCase();
        }
        
        // Find all variant inputs
        const allVariantInputs = Array.from(document.querySelectorAll('input.swatches__form--input'));
        const optionName = document.querySelector('.option-label').textContent.trim();
        
        if (allVariantInputs.length === 0) return;
        
        const searchLower = searchValue.toLowerCase();
        let exactMatch = null;
        let partialMatch = null;
        
        for (const input of allVariantInputs) {
            const inputValue = input.value.toLowerCase();
            const label = document.querySelector(`label[for="${input.id}"]`);
            const labelText = label ? label.textContent.toLowerCase() : '';
        
            // First, check for exact match in input or label
            if (inputValue === searchLower || labelText === searchLower) {
                exactMatch = input;
                break;
            }
        
            // Then, save first partial match as fallback
            if (
                !partialMatch &&
                (inputValue.includes(searchLower) || labelText.includes(searchLower))
            ) {
                partialMatch = input;
            }
        }
        
        const matchedVariant = exactMatch || partialMatch;
        // If we found a match, click it to select AND update the category in properties
        if (matchedVariant) {
            
            // First, get the actual option text this represents
            let selectedOptionText = "";
            const optionLabel = document.querySelector(`label[for="${matchedVariant.id}"]`);
            
            if (optionLabel) {
                selectedOptionText = optionLabel.textContent.trim();

                if(!selectedOptionText) {
                  // Fallback: try to extract option from searchValue
                  selectedOptionText = searchValue.charAt(0).toUpperCase() + searchValue.slice(1);
                }
            } else {
                // Fallback: try to extract option from searchValue
                selectedOptionText = searchValue.charAt(0).toUpperCase() + searchValue.slice(1);
            }
            
            // 1. Update the line item property for the category
            // Find the option's property input
            const propertyInput = document.querySelector(`input[name="properties[${optionName}]"]`);
            
            if (propertyInput) {
                propertyInput.value = selectedOptionText;
                
                // Trigger change event to ensure any listeners know it's updated
                const event = new Event('change', { bubbles: true });
                propertyInput.dispatchEvent(event);
            }
            
            // 2. Click the radio button to update the visible selection
            matchedVariant.click();
        }
    }
    
    // Add event listeners to all swatches
function attachSwatchListeners() {
    // Handle swatch clicks
    document.querySelectorAll('#swatch-container-0 .swatches__form--label, #swatch-container-0 .swatch-item-inner').forEach(swatch => {
        swatch.addEventListener('click', handleSwatchClick);
    });
    
    // Override the variant click behavior
    const productForm = document.querySelector('.product-form');
    if (productForm) {
        const variantSelectors = productForm.querySelectorAll('input[name="id"]');
        
        variantSelectors.forEach(selector => {
            selector.addEventListener('change', function() {
                if (lastSelectedFabric.fabricType && dom.fabricPreview.style.display !== 'block') {
                    setTimeout(() => {
                        // Restore last selected fabric preview with all saved properties
                        updatePreview(
                            lastSelectedFabric.fabricType,
                            lastSelectedFabric.imageUrl,
                            lastSelectedFabric.code,
                            lastSelectedFabric.composition,
                            lastSelectedFabric.isDirect
                        );
                    }, 50);
                }
            });
        });
    }
}
    
// Initialize fabric swiper (slider)
function initializeSlider(sliderContainer, slideCount) {
    if (!sliderContainer) return;
    
    const sliderWrapper = sliderContainer.querySelector('.fabric-swiper-wrapper');
    const slides = Array.from(sliderContainer.querySelectorAll('.fabric-slide'));
    const nextBtn = sliderContainer.querySelector('.flickity-button.next.fabric-nav-btn');
    const prevBtn = sliderContainer.querySelector('.flickity-button.previous.fabric-nav-btn');
    
    if (!sliderWrapper || slides.length === 0) return;
    
    // Hide navigation buttons if fewer than 2 slides
    if (slideCount < 2) {
        if (nextBtn) nextBtn.style.display = 'none';
        if (prevBtn) prevBtn.style.display = 'none';

        // Ensure single-slide swatches are visible and preloaded immediately.
        slides.forEach((slide, index) => {
            slide.style.display = index === 0 ? 'block' : 'none';
            slide.style.paddingLeft = '60px';
            slide.style.paddingRight = '60px';
            slide.style.boxSizing = 'border-box';
        });

        const firstSlideSwatches = slides[0].querySelectorAll('.swatches__form--label[data-lazy-image]');
        firstSlideSwatches.forEach(swatch => {
            if (!swatch.classList.contains('loaded') && !swatch.classList.contains('loading')) {
                loadSwatchImage(swatch);
            }
        });

        return;
    }
    
    let currentIndex = 0;
    
    // Hide all slides except the first one initially
    slides.forEach((slide, index) => {
        slide.style.display = index === 0 ? 'block' : 'none';
        slide.style.paddingLeft = '60px';
        slide.style.paddingRight = '60px';
        slide.style.boxSizing = 'border-box';
    });
    
    // Position the navigation buttons
    if (nextBtn) {
        Object.assign(nextBtn.style, {
            position: 'absolute',
            top: '50px',
            transform: 'translateY(-50%)',
            right: '15px',
            zIndex: '10'
        });
    }
    
    if (prevBtn) {
        Object.assign(prevBtn.style, {
            position: 'absolute',
            top: '50px',
            transform: 'translateY(-50%)',
            left: '15px',
            zIndex: '10'
        });
    }
    
    // Function to update height based on current slide
    function updateHeight() {
        const currentSlide = slides[currentIndex];
        if (!currentSlide) return;
        
        // Wait for any images to load
        setTimeout(() => {
            const slideHeight = currentSlide.offsetHeight;
            sliderContainer.style.height = `${slideHeight + 20}px`;
        }, 50);
    }
    
    // Function to show a specific slide
    function showSlide(index) {
        // Hide all slides
        slides.forEach(slide => {
            slide.style.display = 'none';
        });
        
        // Show the current slide
        if (slides[index]) {
            slides[index].style.display = 'block';
            
            // Load images in this slide if needed
            const swatches = slides[index].querySelectorAll('.swatches__form--label[data-lazy-image]');
            swatches.forEach(swatch => {
                if (!swatch.classList.contains('loaded') && !swatch.classList.contains('loading')) {
                    loadSwatchImage(swatch);
                }
            });
            
            // Update height after showing
            updateHeight();
        }
    }
    
    // Navigation functions
    function goToSlide(index) {
        currentIndex = index;
        showSlide(currentIndex);
        
        // Preload adjacent slides
        const prevIndex = currentIndex > 0 ? currentIndex - 1 : slides.length - 1;
        const nextIndex = currentIndex < slides.length - 1 ? currentIndex + 1 : 0;
        
        [prevIndex, nextIndex].forEach(adjacentIndex => {
            const adjacentSlide = slides[adjacentIndex];
            if (adjacentSlide) {
                const swatches = adjacentSlide.querySelectorAll('.swatches__form--label[data-lazy-image]');
                swatches.forEach(swatch => {
                    if (!swatch.classList.contains('loaded') && !swatch.classList.contains('loading')) {
                        loadSwatchImage(swatch);
                    }
                });
            }
        });
    }
    
    // Navigation button handlers
    if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const nextIndex = currentIndex < slides.length - 1 ? currentIndex + 1 : 0;
            goToSlide(nextIndex);
        });
    }
    
    if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const prevIndex = currentIndex > 0 ? currentIndex - 1 : slides.length - 1;
            goToSlide(prevIndex);
        });
    }
    
    // Initialize container styles
    Object.assign(sliderContainer.style, {
        overflow: 'hidden',
        position: 'relative',
        transition: 'height 0.3s ease'
    });
    
    // Simple touch handling
    let touchStartX = 0;
    let touchEndX = 0;
    
    sliderContainer.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
    }, { passive: true });
    
    sliderContainer.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].clientX;
        const diff = touchStartX - touchEndX;
        
        if (Math.abs(diff) > 50) { // Minimum swipe distance
            if (diff > 0) {
                // Swipe left - next slide
                const nextIndex = currentIndex < slides.length - 1 ? currentIndex + 1 : 0;
                goToSlide(nextIndex);
            } else {
                // Swipe right - previous slide
                const prevIndex = currentIndex > 0 ? currentIndex - 1 : slides.length - 1;
                goToSlide(prevIndex);
            }
        }
    }, { passive: true });
    
    // Window resize handler
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateHeight, 250);
    });
    
    // Watch for image loads in current slide
    const observeImageLoads = () => {
        const currentSlide = slides[currentIndex];
        if (currentSlide) {
            const images = currentSlide.querySelectorAll('img, .swatches__form--label');
            images.forEach(img => {
                if (img.complete || img.classList.contains('loaded')) {
                    updateHeight();
                } else {
                    img.addEventListener('load', updateHeight, { once: true });
                }
            });
        }
    };
    
    // Initialize
    showSlide(0);
    observeImageLoads();
    
    // Force initial height calculation after a delay
    setTimeout(() => {
        updateHeight();
        
        // Load images in first slide
        const firstSlideSwatches = slides[0].querySelectorAll('.swatches__form--label[data-lazy-image]');
        firstSlideSwatches.forEach(swatch => {
            if (!swatch.classList.contains('loaded') && !swatch.classList.contains('loading')) {
                loadSwatchImage(swatch);
            }
        });
    }, 100);
}
   // Start loading data
   loadData();
   
// Initialize 3D model texture handling with unified system
const modelViewer = dom.modelViewer; // Use cached reference
if (modelViewer) {
    // Pre-load base materials before setting up listeners
    preloadBaseMaterials().then(() => {
        modelViewer.addEventListener('load', async () => {
            // Setup universal option listeners for all options
            await setupUniversalOptionListeners();
            
            // Initialize product mapping and set default visibility
            const productMapping = await getProductMapping(modelViewer);
            if (productMapping) {
                
                // Store mapping in modelViewer for later use
                if (!modelViewer.userData) modelViewer.userData = {};
                modelViewer.userData.productMapping = productMapping;
                
                // Check each option group for initial state
                const allOptionGroups = document.querySelectorAll('.swatch');
                
                for (let i = 0; i < allOptionGroups.length; i++) {
                    const group = allOptionGroups[i];
                    const optionLabel = group.querySelector('.option-label');
                    
                    // Parse option name properly
                    let optionName = null;
                    if (optionLabel) {
                        const fullText = optionLabel.textContent.trim();
                        // Split by | and take the first part
                        optionName = fullText.split('|')[0].trim();
                    }
                    
                    
                    if (optionName && productMapping[optionName]) {

                        
                        // Find selected value
                        const checkedInput = group.querySelector('input:checked');
                        let selectedValue = null;
                        
                        if (checkedInput) {
                            const labelElement = document.querySelector(`label[for="${checkedInput.id}"]`);
                            selectedValue = labelElement ? labelElement.textContent.trim() : checkedInput.value;
                        } else {
                        }
                        
                        // Apply mesh visibility
                        const optionMapping = productMapping[optionName];
                        let meshToShow = null;
                        
                        if (selectedValue && optionMapping[selectedValue] && optionMapping[selectedValue].mesh) {
                            meshToShow = optionMapping[selectedValue].mesh;
                        } else if (productMapping.default) {
                            // No selection or selection not found, use default
                            const defaultValue = productMapping.default;
                            if (optionMapping[defaultValue] && optionMapping[defaultValue].mesh) {
                                meshToShow = optionMapping[defaultValue].mesh;
                            }
                        }
                        
                        if (meshToShow) {
                            updateMeshVisibility(modelViewer, meshToShow);
                        } else {
                        }
                    }
                }
            }
            
            // Check if there's already a selected swatch and apply its texture
            setTimeout(() => {
                const selectedSwatch = document.querySelector('.swatches__form--label.selected');
                if (selectedSwatch) {
                    const fabricType = selectedSwatch.dataset.fabricType;
                    handleOptionChange(0, fabricType, selectedSwatch);
                }
            }, 500);
        });
    });
    
    modelViewer.addEventListener('error', (event) => {
        console.error('Model viewer error:', event);
    });
} else {
    // Still setup universal listeners even without 3D model
    preloadBaseMaterials().then(() => {
        setupUniversalOptionListeners();
    });
}
});